const normalizeSlug = (value = '') =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '');

export const getCategoryInfo = (category) => {
  if (!category) {
    return { id: null, name: 'Uncategorized' };
  }

  const name = category.Name || category.name || category.Slug || category.slug || 'Uncategorized';
  const rawSlug = category.Slug || category.slug || '';
  const slugSource = normalizeSlug(rawSlug).length > 1 ? rawSlug : name;
  let id = normalizeSlug(slugSource);

  if (id.includes('metal')) {
    id = 'metalframe';
  } else if (id.includes('plastic')) {
    id = 'plastic';
  } else if (id.includes('unbreakable')) {
    id = 'unbreakableframe';
  } else if (id.includes('comfort')) {
    id = 'comfortlenses';
  }

  return { id, name };
};

export const buildCategoriesFromProducts = (products, allLabel = 'All Categories', extraCategories = []) => {
  const categoryMap = new Map();

  products.forEach((product) => {
    if (product.category) {
      categoryMap.set(product.category, product.categoryName || product.category);
    }
  });

  extraCategories.forEach((category) => {
    categoryMap.set(category.id, category.name);
  });

  return [
    { id: 'all', name: allLabel },
    ...Array.from(categoryMap, ([id, name]) => ({ id, name })),
  ];
};
